export const getStatus = (statusCode) => {
    switch (statusCode) {
        case 'NewApplication':
            return `Cais Newydd`;
        case 'AwaitingResponse':
            return `Yn aros am gymeradwyaeth`;
        case 'Approved':
            return '';
        case 'ChangesRequested':
            return `Gofynnwyd am rai newidiadau. Cymerwch gip ar eich e-bost am fanylion.`;
        case 'Rejected':
            return `Gwrthodwyd eich cais. Cysylltwch \u00E2\u2019r t\u00EEm cymorth am ragor o wybodaeth.`;
        default:
            return '';
    }
};
export const getTier = (tier) => {
    switch (tier) {
        case 'Tier1':
            return `Rhagflas`;
        case 'Tier2':
            return `Essential`;
        case 'Tier3':
            return `Plus`;
        default:
            return '';
    }
};
export const getRole = (role) => {
    switch (role) {
        case 'ADMIN':
            return `Prif weinyddwr`;
        case 'MANAGER':
            return `Gweinyddwr`;
        case 'CULTURAL_MANAGER':
            return `Cydlynydd Mynediad`;
        case 'TEAM_MEMBER':
            return `Cydlynydd mynediad`;
        default:
            return '';
    }
};
export const getInviteStatus = (status) => {
    switch (status) {
        case 'Invited':
            return 'Pending - invite sent';
        case 'Accepted':
            return 'Accepted';
        case 'Rejected':
            return 'Rejected';
        default:
            return '';
    }
};
